import React from 'react';
import OrderDesign from '../OrderDesign';
import './StrategicForecastDialog.css';

/**
 * Strategic Forecast Dialog Component
 * Displays when strategem 323 (Strategic Forecast) is played
 * Shows 3 random orders side by side with "Keep" buttons below each
 * When "Keep" is clicked, all orders disappear and selected order goes to hand
 */
const StrategicForecastDialog = ({ orders, onSelectOrder, ws, gameId }) => {
  const [selectedOrderId, setSelectedOrderId] = React.useState(null);
  const [selectionMade, setSelectionMade] = React.useState(false);

  // Debug logging
  React.useEffect(() => {
    console.log('🔮 StrategicForecastDialog: Component mounted/updated', {
      ordersCount: orders?.length,
      orders: orders,
      selectionMade,
      wsReady: ws?.readyState === 1,
      gameId
    });
  }, [orders, selectionMade, ws, gameId]);

  // Early return if no orders or selection already made
  if (!orders || orders.length === 0 || selectionMade) {
    console.log('🔮 StrategicForecastDialog: Not rendering -', {
      noOrders: !orders,
      emptyOrders: orders?.length === 0,
      selectionMade
    });
    return null;
  }

  const handleKeep = (orderId) => {
    if (!ws || ws.readyState !== 1) {
      console.error('🔮 Strategic Forecast: WebSocket not ready');
      return;
    }

    console.log('🔮 Strategic Forecast: Keeping order', orderId);

    // Mark selection as made (hide all orders)
    setSelectedOrderId(orderId);
    setSelectionMade(true);

    // Send selection to backend
    const message = {
      type: "play-turn",
      gameId,
      action: {
        type: "selectStrategicForecast",
        selectedOrderId: orderId
      }
    };

    console.log('🔮 Strategic Forecast: Sending WebSocket message:', message);
    ws.send(JSON.stringify(message));
  };

  return (
    <div className="strategic-forecast-overlay">
      <div className="strategic-forecast-dialog">
        <div className="strategic-forecast-header">
          <h2>🔮 Strategic Forecast</h2>
          <p>Choose one order to keep:</p>
        </div>

        <div className="strategic-forecast-orders-display">
          {orders.map((order, index) => (
            <div key={order.id || index} className="strategic-forecast-order-card">
              <OrderDesign
                order={order}
                count={0}
                minimal={false}
                isOOR={false}
                isSelected={false}
                isTarget={false}
              />
              <button
                className="strategic-forecast-keep-button"
                onClick={() => handleKeep(order.id)}
                disabled={selectionMade}
              >
                Keep
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StrategicForecastDialog;

